// extracted by mini-css-extract-plugin
module.exports = {"comp":"ProductNav_comp__J_c1j"};